export default __webpack_public_path__ + "static/media/tl1.5530c1cd.png";